import { defineCustomElements } from '@ionic/pwa-elements/loader'
import React from 'react'
import { createRoot } from 'react-dom/client'

import './lib/i18n'
import './lib/native'

import App from './App'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window)

const container = document.getElementById('root')

createRoot(container!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
